import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";

export default function StickyBar({
  label = "Start free month →",
  subLabel = "",
  loading = false,
  loadingLabel = "Loading…",
  disabled = false,
  onClick,
  secondaryLabel = "",
  secondaryLoading = false,
  secondaryLoadingLabel = "Loading…",
  secondaryDisabled = false,
  onSecondaryClick,
  visible = true,
  className = "",
  subLabelClassName = "",
  secondaryClassName = "",
  containerClassName = "",
  desktopVisible = false,
}) {
  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/80 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] backdrop-blur-xl ${
        desktopVisible ? "md:flex md:justify-between" : "md:hidden"
      } ${containerClassName}`}
    >
      <div
        className={`flex w-full items-center gap-3 ${
          desktopVisible
            ? secondaryLabel
              ? "md:justify-between"
              : "md:justify-end"
            : ""
        }`}
      >
        {secondaryLabel ? (
          <Button
            type="button"
            variant="outline"
            onClick={onSecondaryClick}
            size="lg"
            disabled={secondaryDisabled || secondaryLoading}
            className={`h-14 flex-1 rounded-2xl text-base font-semibold ${
              desktopVisible ? "md:h-11 md:w-auto md:min-w-[9rem] md:flex-none md:rounded-xl md:px-5 md:text-sm" : ""
            } ${secondaryClassName}`}
          >
            {secondaryLoading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                {secondaryLoadingLabel}
              </>
            ) : (
              secondaryLabel
            )}
          </Button>
        ) : null}

        <div
          className={`${secondaryLabel ? "flex-1" : "w-full"} ${
            desktopVisible ? "md:w-auto md:flex-none md:min-w-[13rem]" : ""
          }`}
        >
          <Button
            onClick={onClick}
            size="lg"
            disabled={disabled || loading}
            className={`h-14 w-full rounded-2xl text-base font-semibold shadow-lg shadow-primary/20 ${
              desktopVisible ? "md:h-11 md:w-auto md:min-w-[13rem] md:rounded-xl md:px-5 md:text-sm" : ""
            } ${className}`}
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                {loadingLabel}
              </>
            ) : (
              label
            )}
          </Button>
          {subLabel ? (
            <p
              className={`mt-2 text-center text-xs text-muted-foreground ${
                desktopVisible ? "md:text-right" : ""
              } ${subLabelClassName}`}
            >
              {subLabel}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
